var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800095 7.19998H7.19998V0.799949C7.19998 0.358446 7.55842 0 8.00007 0C8.44158 0 8.80002 0.358446 8.80002 0.799949V7.19998H15.2001C15.6416 7.19998 16 7.55842 16 7.99993C16 8.44158 15.6416 8.80002 15.2001 8.80002H8.80002V15.1999C8.80002 15.6416 8.44158 16 8.00007 16C7.55842 16 7.19998 15.6416 7.19998 15.1999V8.80002H0.800095C0.358445 8.80002 0 8.44158 0 7.99993C0 7.55842 0.358445 7.19998 0.800095 7.19998Z",
    fill: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusGray);
export default __webpack_public_path__ + "static/media/icon_plus_gray.ef6a1baf348c073eb3d348568c188164.svg";
export { ForwardRef as ReactComponent };